import React, {ButtonHTMLAttributes, forwardRef, ReactNode} from 'react';

import {Spinner} from '../Spinner';

import {ButtonVariant} from './constants';
import {IconWrapper, Inner, LoadingIndicatorContainer, NativeButton} from './styled';

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
    icon?: ReactNode;
    isLoading?: boolean;
    disabled?: boolean;
    variant?: ButtonVariant;
    size?: 'sm' | 'md' | 'lg';
}

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(
    (
        {
            children,
            icon,
            isLoading = false,
            disabled = false,
            variant = ButtonVariant.Normal,
            size = 'md',
            ...otherProps
        },
        ref,
    ) => (
        <NativeButton
            ref={ref}
            isLoading={isLoading}
            disabled={disabled || isLoading}
            variant={variant}
            size={size}
            {...otherProps}
        >
            {isLoading && (
                <LoadingIndicatorContainer>
                    <Spinner color="current" />
                </LoadingIndicatorContainer>
            )}

            <Inner>
                {icon && <IconWrapper>{icon}</IconWrapper>}
                {children}
            </Inner>
        </NativeButton>
    ),
);

export {ButtonVariant};
